import FreeItemsBlock from './freeItemsBlock'

export default FreeItemsBlock
